var _path, _path2, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRemoveFavourite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 13.125C18.75 10.0184 16.2316 7.5 13.125 7.5C10.0184 7.5 7.5 10.0184 7.5 13.125C7.5 16.2316 10.0184 18.75 13.125 18.75C16.2316 18.75 18.75 16.2316 18.75 13.125Z",
    fill: "#0A4468"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5591 6.27297L10.5605 2.2234C10.3313 1.75887 9.66885 1.75887 9.43959 2.2234L7.19714 6.76712L2.18284 7.49574C1.6702 7.57023 1.46551 8.2002 1.83646 8.56179L5.46484 12.0986L4.60829 17.0926C4.52073 17.6031 5.05661 17.9925 5.51514 17.7515L7.31645 16.8045C6.6411 15.7405 6.25 14.4785 6.25 13.125C6.25 9.51859 9.02686 6.56075 12.5591 6.27297Z",
    fill: "#0A4468"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 12,
    width: 6,
    height: 2,
    rx: 1,
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveFavourite);
export default __webpack_public_path__ + "static/media/remove-favourite.eef6284fd56885a899695ecb2f8e0ac6.svg";
export { ForwardRef as ReactComponent };